export enum Plan {
  FREE = "FREE",
  PRO = "PRO",
  PLUS = "PLUS",
  PREMIUM = "PREMIUM",
  STUDENT_PASS = "STUDENT_PASS",
  PRO_TRIAL = "PRO_TRIAL",
}

export enum SubscriptionCycle {
  MONTHLY = "MONTHLY",
  YEARLY = "YEARLY",
}

export enum SubscriptionStatus {
  ACTIVE = "ACTIVE",
  PENDING_PAYMENT = "PENDING_PAYMENT",
  PENDING_CANCELLATION = "PENDING_CANCELLATION",
  PENDING_PLAN_CHANGE = "PENDING_PLAN_CHANGE",
}

export enum Platform {
  TOSS = "TOSS",
  IOS = "IOS",
  ANDROID = "ANDROID",
  STRIPE = "STRIPE",
}

export enum ArticleType {
  BLOG = "BLOG",
  PREMIUM = "PREMIUM",
}

export enum Language {
  EN = "en",
  KO = "ko",
}

export enum ExperimentStatus {
  DRAFT = "DRAFT",
  RUNNING = "RUNNING",
  PAUSED = "PAUSED",
  COMPLETED = "COMPLETED",
}
